import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationProtocolOntologyCreateRequest,
    ConfigurationProtocolOntologyResponse
} from '@/modules/configurationModule/detail/local-assays/protocols/services/configuration-protocol-ontology/configuration-protocol-ontology.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationProtocolOntologyService {
    async create(laboratoryId: number, request: ConfigurationProtocolOntologyCreateRequest): Promise<ConfigurationProtocolOntologyResponse> {
        const response = await axios.post<ConfigurationProtocolOntologyResponse>(`/configuration/laboratories/${laboratoryId}/protocolOntologies`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationProtocolOntologyResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationProtocolOntologyResponse>>(`/configuration/laboratories/${laboratoryId}/protocolOntologies`, { ...filterModel }, { params })
        return response.data
    }

    async get(protocolOntologyId : number, laboratoryId: number): Promise<ConfigurationProtocolOntologyResponse> {
        const response = await axios.get<ConfigurationProtocolOntologyResponse>(`/configuration/laboratories/${laboratoryId}/protocolOntologies/${protocolOntologyId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/protocolOntologies/batch`, { data: request })
        return response.data
    }
}

export const configurationProtocolOntologyService = new ConfigurationProtocolOntologyService()
